import { API_CONSULT } from 'Constants/client-modules';

import * as ACTION_TYPES from './types';

export function getPubnubConfig() {
  return {
    types: [
      ACTION_TYPES.PUNUB_CONFIG_GET_REQUESTED,
      ACTION_TYPES.PUNUB_CONFIG_GET_SUCCEED,
      ACTION_TYPES.PUNUB_CONFIG_GET_FAILED,
    ],
    promise: client => client.get('configs/pubnub-config'),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function grantToken() {
  return {
    types: [
      ACTION_TYPES.PUNUB_GRANT_TOKEN_REQUESTED,
      ACTION_TYPES.PUNUB_GRANT_TOKEN_SUCCEED,
      ACTION_TYPES.PUNUB_GRANT_TOKEN_FAILED,
    ],
    promise: client => client.post('pubnub/grant-token'),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function initPubnub() {
  return {
    type: ACTION_TYPES.PUBNUB_INIT,
  };
}

export function destroyPubnub() {
  return {
    type: ACTION_TYPES.PUBNUB_DESTROY,
  };
}
